import { TDataLayer, TEvent } from '@typescript/index';
import { IItemPurchase } from '@reaffiliates/typescript';
const GoogleTagManagerItemList = (items: IItemPurchase[], listingType: string, listingId: number, event: TEvent = 'view_item_list') => {
  const tagManagerArgs: TDataLayer = {
    event,
    ecommerce: {
      item_list_id: listingId.toString() || listingType,
      item_list_name: listingType,
      items
    }
  };
  if (window && window.dataLayer) {
    window.dataLayer.push({
      ecommerce: null
    });
    window.dataLayer.push(tagManagerArgs);
  }
};
export default GoogleTagManagerItemList;